import {
  DateFromForNextCutoffDto,
  getCutoffsCompanyIDDateFromForNextCutoff,
} from "Api/Api";
import { createAsyncAction, getType } from "typesafe-actions";
import { call, put, takeLatest } from "typed-redux-saga";
import { createSlice } from "@reduxjs/toolkit";
import { mapAPIErrorResponse } from "Models/Errors/ApiCallError";
import {
  getFetchStateDefaultValue,
  handleFailureCase,
  handleRequestCase,
  handleSuccessCase,
} from "State/Utils";

export const getNextCutoffDateFromAsync = createAsyncAction(
  "@cutoff/GET_NEXT_DATE_FROM_REQUEST",
  "@cutoff/GET_NEXT_DATE_FROM_RESPONSE",
  "@cutoff/GET_NEXT_DATE_FROM_FAILURE",
)<
  {
    companyID: number;
  },
  DateFromForNextCutoffDto,
  Error
>();

function* getNextCutoffDateFrom(
  action: ReturnType<typeof getNextCutoffDateFromAsync.request>,
): Generator {
  try {
    const { data, error, status } = yield* call(
      getCutoffsCompanyIDDateFromForNextCutoff,
      action.payload.companyID,
    );

    if (status === 200) {
      yield put(getNextCutoffDateFromAsync.success(data));
      return;
    }

    yield put(
      getNextCutoffDateFromAsync.failure(mapAPIErrorResponse(error ?? data)),
    );
  } catch (err) {
    yield put(getNextCutoffDateFromAsync.failure(err as Error));
  }
}
export function* getNextCutoffDateFromSaga() {
  yield takeLatest(
    getType(getNextCutoffDateFromAsync.request),
    getNextCutoffDateFrom,
  );
}

export const getNextCutoffDateFromSlice = createSlice({
  initialState: getFetchStateDefaultValue<DateFromForNextCutoffDto>(false),
  name: "@cutoff/getNextCutoffDateFrom",
  reducers: {
    resetSlice: () =>
      getFetchStateDefaultValue<DateFromForNextCutoffDto>(false),
  },
  extraReducers: builder => {
    handleRequestCase(getNextCutoffDateFromAsync, builder);
    handleSuccessCase(getNextCutoffDateFromAsync, builder);
    handleFailureCase(getNextCutoffDateFromAsync, builder);
  },
});

export const { resetSlice } = getNextCutoffDateFromSlice.actions;
